/**
 *
 */
export declare interface IEpubCfiSpatialOffset {

    /**
     * A value between 0 to 100.
     */
    x: number;

    /**
     * A value between 0 to 100.
     */
    y: number;
}
